import { Download } from 'lucide-react'
import { Button } from '@/components/shadcn/button'

export function DownloadButton({ url }: { url: string | null }) {
  if (!url) return <span className="text-muted-foreground text-sm">—</span>
  return (
    <Button variant="ghost" size="icon" asChild>
      <a href={url} download target="_blank" rel="noreferrer">
        <Download className="size-4" />
      </a>
    </Button>
  )
}
